const temperatureGraphColorData: { [index: string]: string } = {
  "Output": "#6E178C",
  "Target": "#0002FD",
  "Feedback": "#F77474",
  "Average": "#9B51E0",
  "Maximum": "#FF0000",
  "Minimum": "#65D5FA",
  "Top": "#0D552C",
  "Middle": "#E92FED",
  "Bottom": "#F2994A",
  "Ambient": "#6B2220"
};

class TemperatureGraphColor {
  static getTemperatureGraphColor(sensorName?: string): string {
    const unknownColor = "#000000";
    if (sensorName == null) {
      return unknownColor;
    }
    var color = temperatureGraphColorData[sensorName];
    if (color == null) {
      return unknownColor;
    }
    return color;
  }
}

export default TemperatureGraphColor;
